import { render, staticRenderFns } from "./MoreMenuProfileInfo.vue?vue&type=template&id=1a7d62b9&"
import script from "./MoreMenuProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuProfileInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports